import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 10"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M4.488 3.12a.25.25 0 0 0-.25-.25H1.5a1 1 0 0 0-1 .989v1.023a.994.994 0 0 0 1 .988h2.742a.25.25 0 0 0 .25-.25Zm5.012.739a1 1 0 0 0-1-.989H5.738a.25.25 0 0 0-.177.074.25.25 0 0 0-.073.177v2.5a.25.25 0 0 0 .25.249H8.5a.994.994 0 0 0 1-.988Zm-5 3.261a.25.25 0 0 0-.25-.25H1.5a.5.5 0 0 0-.5.5v1.512a.994.994 0 0 0 1 .988h2.249a.25.25 0 0 0 .177-.07.26.26 0 0 0 .074-.18Zm1.245-.25a.25.25 0 0 0-.177.074.25.25 0 0 0-.073.177v2.5a.25.25 0 0 0 .25.249H8a.994.994 0 0 0 1-.988V7.37a.5.5 0 0 0-.5-.5ZM6.8.23a.5.5 0 0 0-.7.1L5 1.8 3.9.33a.5.5 0 0 0-.8.6l1.5 2a.5.5 0 0 0 .8 0l1.5-2a.5.5 0 0 0-.1-.7"
    }, null, -1)
  ]));
}
const shoppingGiftPresent = { render };
export {
  shoppingGiftPresent as default,
  render
};
//# sourceMappingURL=shopping-gift-present.svg.js.map
